webpackJsonp([263791100135453],{

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\nwidth: 90%;\nmax-width: 400px;\nmargin:30px auto 10px;\ndisplay:block;\n'], ['\nwidth: 90%;\nmax-width: 400px;\nmargin:30px auto 10px;\ndisplay:block;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\nwidth: 100%;\nmax-width: 800px;\nmargin: 10px auto;\ndisplay: block;\n'], ['\nwidth: 100%;\nmax-width: 800px;\nmargin: 10px auto;\ndisplay: block;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\ndisplay:flex;\nflex-direction: column;\njustify-content: center;\ntext-align: center;\n'], ['\ndisplay:flex;\nflex-direction: column;\njustify-content: center;\ntext-align: center;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\nwidth: 100%;\nbackground-image: url("/about/img/main_background.jpg");\nvertical-align: bottom;\n'], ['\nwidth: 100%;\nbackground-image: url("/about/img/main_background.jpg");\nvertical-align: bottom;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\nbackground-color: #d8000b;\n'], ['\nbackground-color: #d8000b;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\nbackground-color: #6cb545;\n'], ['\nbackground-color: #6cb545;\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\nfont-size: 1.4rem;\nline-height: 2.8rem;\ndisplay:block;\n\n'], ['\nfont-size: 1.4rem;\nline-height: 2.8rem;\ndisplay:block;\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(23);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(13);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _layout = __webpack_require__(16);
	
	var _theme = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeadImage = _styledComponents2.default.img(_templateObject);
	var Image = _styledComponents2.default.img(_templateObject2);
	var Section = _styledComponents2.default.section(_templateObject3);
	var MainVisualWrapper = _styledComponents2.default.div(_templateObject4);
	var SystemWrapper = _styledComponents2.default.div(_templateObject5);
	var ContentsChannelWrapper = _styledComponents2.default.div(_templateObject6);
	var Paragraph = _styledComponents2.default.p(_templateObject7);
	
	var AboutPage = function AboutPage(props) {
	  return _react2.default.createElement(
	    Section,
	    { className: 'about' },
	    _react2.default.createElement(
	      MainVisualWrapper,
	      null,
	      _react2.default.createElement(Image, { src: '/about/img/main.png', alt: '\u30D5\u30A1\u30F3\u306E\u89B3\u305F\u3044\u3092\u30D5\u30A1\u30F3\u3068\u3064\u304F\u308B\u756A\u7D44\u30E1\u30C7\u30A3\u30A2 Flick!On!TV \uFF08\u7121\u6599\uFF09' })
	    ),
	    _react2.default.createElement(
	      _layout.FrameContainer,
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        _react2.default.createElement(HeadImage, { src: '/about/img/catch.png', alt: '\u30D5\u30EA\u30C3\u30AF\u30AA\u30F3TV\u3068\u306F\uFF1F' })
	      ),
	      _react2.default.createElement(
	        Paragraph,
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          ' \u300E\u30D5\u30A1\u30F3\u306E\u89B3\u305F\u3044\u3092\u30D5\u30A1\u30F3\u3068\u3064\u304F\u308B\u756A\u7D44\u30E1\u30C7\u30A3\u30A2\u300F'
	        )
	      ),
	      _react2.default.createElement(
	        Paragraph,
	        null,
	        'Flick!On!TV\uFF08\u30D5\u30EA\u30C3\u30AF\u30AA\u30F3TV\uFF09\u306F\u3001\u6BCE\u65E5\u7121\u6599\u3067\u3082\u3089\u3048\u308BF!P\uFF08\u30D5\u30EA\u30C3\u30AF\u30DD\u30A4\u30F3\u30C8\uFF09\u3092\u756A\u7D44\u306B\u30D5\u30EA\u30C3\u30AF\u30AA\u30F3\uFF08\uFF1D\u5FDC\u63F4\uFF09\u3059\u308B\u3053\u3068\u3067\u3001\u756A\u7D44\u3084\u51FA\u6F14\u8005\u3092\u5FDC\u63F4\u3067\u304D\u308B\u65B0\u611F\u899A\u30B9\u30DE\u30DB\u30E1\u30C7\u30A3\u30A2\u30A2\u30D7\u30EA\u3067\u3059\u3002'
	      ),
	      _react2.default.createElement(Image, { src: '/about/img/crowd.png', alt: '\u7279\u9577\u30A4\u30E1\u30FC\u30B8' }),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(HeadImage, { src: '/about/img/head_video.png', alt: '30\u79D2\u3067\u308F\u304B\u308BFlick!On!TV\u52D5\u753B', id: 'imgsrc17023437_1', className: ' c-no_adjust' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://www.youtube.com/watch?v=-hOoKpi9C8Y', target: '_blank' },
	        _react2.default.createElement(Image, { src: '/about/img/youtube.jpg', alt: 'YouTube\u3067\u89B3\u308B', id: 'imgsrc17023435_1', className: ' c-no_adjust' })
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(HeadImage, { src: '/about/img/tokucho.png', alt: 'Flick!On!TV\u306E\u7279\u9577', id: 'imgsrc17023357_1', className: ' c-no_adjust' })
	      ),
	      _react2.default.createElement(
	        Paragraph,
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '\u3059\u3079\u3066\u3001\u30AA\u30EA\u30B8\u30CA\u30EB\u756A\u7D44\uFF01'
	        ),
	        _react2.default.createElement('br', null),
	        '\u5287\u5834\u3084\u30E1\u30C7\u30A3\u30A2\u3067\u6D3B\u8E8D\u4E2D\u306E\u3001\u5B9F\u529B\u3042\u308B\u3088\u3057\u3082\u3068\u82E5\u624B\u82B8\u4EBA\u306A\u3069\u304C\u51FA\u6F14\u3057\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(HeadImage, { src: '/about/img/ttl.png', alt: '\u307F\u3093\u306A\u3067\u756A\u7D44\u3084\u30BF\u30EC\u30F3\u30C8\u3092\u5FDC\u63F4\u3057\u3088\u3046\uFF01 \u7D9A\u7DE8\u914D\u4FE1\u306F\u3042\u306A\u305F\u306E\u5FDC\u63F4\u6B21\u7B2C\uFF01', id: 'imgsrc17023361_1', className: ' c-no_adjust' }),
	      _react2.default.createElement(
	        Paragraph,
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          '\u30D5\u30EA\u30C3\u30AF\u30AA\u30F3\u3055\u308C\u305FF!P\uFF08\u30D5\u30EA\u30C3\u30AF\u30DD\u30A4\u30F3\u30C8\uFF09\u304C\u76EE\u6A19\u30DD\u30A4\u30F3\u30C8\u6570\u306B\u5230\u9054\u3059\u308B\u3068\u7D9A\u7DE8\u306E\u914D\u4FE1\u304C\u6C7A\u5B9A\uFF01'
	        )
	      ),
	      _react2.default.createElement(
	        Paragraph,
	        null,
	        '\u6BCE\u65E5\u7121\u6599\u3067\u3082\u3089\u3048\u308B\u30A2\u30D7\u30EA\u5185\u4EEE\u60F3\u30DD\u30A4\u30F3\u30C8\u300EF!P\uFF08\u30D5\u30EA\u30C3\u30AF\u30DD\u30A4\u30F3\u30C8\uFF09\u300F\u3092\u3001\u304A\u6C17\u306B\u5165\u308A\u306E\u756A\u7D44\u306B\u30D5\u30EA\u30C3\u30AF\u30AA\u30F3\uFF08\uFF1D\u5FDC\u63F4\uFF09\u3057\u307E\u3057\u3087\u3046\uFF01'
	      ),
	      _react2.default.createElement(
	        SystemWrapper,
	        null,
	        _react2.default.createElement(Image, { src: '/about/img/system.png', alt: 'STEP1 F!P\uFF08\u30D5\u30EA\u30C3\u30AF\u30DD\u30A4\u30F3\u30C8\uFF09\u3092\u4F7F\u3063\u3066\u3001\u304A\u6C17\u306B\u5165\u308A\u756A\u7D44\u3092\u307F\u3093\u306A\u3067\u5FDC\u63F4\uFF01 STEP2 \u76EE\u6A19\u30DD\u30A4\u30F3\u30C8\u9054\u6210\u3067\u3001\u7D9A\u7DE8\u306E\u914D\u4FE1\u304C\u6C7A\u5B9A\uFF01', id: 'imgsrc17023363_1' })
	      ),
	      _react2.default.createElement('hr', null),
	      _react2.default.createElement(
	        ContentsChannelWrapper,
	        null,
	        _react2.default.createElement(Image, { src: '/about/img/contents_channel.png', alt: '\u30B3\u30F3\u30C6\u30F3\u30C4\u30C1\u30E3\u30F3\u30CD\u30EB\u3000\u3042\u306A\u305F\u304C\u756A\u7D44\u3092\u6C17\u306B\u5165\u3063\u305F\u308A\u3001\u7D9A\u7DE8\u3092\u89B3\u305F\u3044\u3068\u601D\u3063\u305F\u3089\u3001F!P\uFF08\u30D5\u30EA\u30C3\u30AF\u30DD\u30A4\u30F3\u30C8\uFF09\u3067\u5FDC\u63F4\u3057\u3088\u3046\uFF01', id: 'imgsrc17023365_1' })
	      ),
	      _react2.default.createElement(
	        Paragraph,
	        null,
	        'Flick!On!TV\u30AA\u30EA\u30B8\u30CA\u30EB\u756A\u7D44\u3092\u8996\u8074\u3067\u304D\u308B\u30C1\u30E3\u30F3\u30CD\u30EB\u3067\u3059\u3002\u756A\u7D44\u3092\u6C17\u306B\u5165\u3063\u305F\u308A\u3001\u7D9A\u7DE8\u3092\u898B\u305F\u3044\u3068\u601D\u3063\u305F\u3089\u3001F!P\uFF08\u30D5\u30EA\u30C3\u30AF\u30DD\u30A4\u30F3\u30C8\uFF09\u3067\u5FDC\u63F4\u3057\u307E\u3057\u3087\u3046\u3002\u76EE\u6A19\u30DD\u30A4\u30F3\u30C8\u306B\u5230\u9054\u3059\u308B\u3068\u7D9A\u7DE8\u306E\u914D\u4FE1\u304C\u6C7A\u5B9A\u3057\u307E\u3059\uFF01'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(HeadImage, { src: '/about/img/app_download.png', alt: '\u30A2\u30D7\u30EA\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\uFF08\u7121\u6599\uFF09\u306F\u3053\u3061\u3089\uFF01' })
	      ),
	      _react2.default.createElement(
	        _theme.DownloadButtonWrapper,
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            href: props.data.site.siteMetadata.firebaseDynamicLink },
	          _react2.default.createElement('img', { src: '/img/app_download.png', alt: '\u30A2\u30D7\u30EA\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-72510e5ca7b2ec696f62.js